import { AppLayout } from '@/components/app-layout';
import { AppSumoCopilotGate } from '@/components/appsumo-copilot-gate.component';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { OnboardingCheck } from '@/components/onboarding-check.component';
import { FullScreenCopilot } from '@/containers/copilot/full-screen-copilot.component';
import { createFileRoute } from '@tanstack/react-router';

// Deliberately NOT wrapped in <FeatureGate>. /clu is the activation
// landing surface and must be reachable by free-tier new users - the whole
// point is to cut pre-enrichment drop-off. (Contrast /agents, which is
// starter-tier gated.) Rendered inside AppShell via __root, so the left nav
// persists and the docked sidebar shares one runtime.
//
// It IS, however, fenced from AppSumo-only orgs (<AppSumoCopilotGate>): the
// Copilot is a net-new surface unavailable on AppSumo plans. Free/paid regular
// orgs and stacked Sumolings pass through; the backend /agent/chat 403 is the
// authoritative backstop.
//
// This page used to live at /copilot. That URL now redirects here
// (src/routes/copilot.tsx), so old links keep working.
export const Route = createFileRoute('/clu')({
  component: CluPage,
});

function CluPage() {
  return (
    <>
      <Head heading='Clu' />
      <AuthCheck>
        {/* OnboardingCheck = the Clerk signup-survey gate. /clu is the
            new-user landing + nav target, and its first-run + chat both assume
            the Clerk survey is done (sendMessage is hard-blocked and the
            onboarding research 403s without an org otherwise). Gate it here so
            a not-yet-onboarded user who lands on /clu directly is routed
            through /onboarding instead of hitting a dead end. */}
        <OnboardingCheck>
          <AppLayout variant='full-bleed'>
            <AppSumoCopilotGate>
              <FullScreenCopilot />
            </AppSumoCopilotGate>
          </AppLayout>
        </OnboardingCheck>
      </AuthCheck>
    </>
  );
}
